import React from 'react';
import ServicesTwoSingleItem from '../../../../components/ServicesTwoSingleItem/ServicesTwoSingleItem';
import applications from '../../../../fakeData/applications/applications';
import enApplications from '../../../../fakeData/applications/en-applications';
import { useTranslation } from 'react-i18next';
import SEOHead from '../../../../components/SEO/SEOHead';
import { getApplicationCategoryAlternates } from '../../../../utils/seoMappings';

const ServicesTwoArea = ({ data }) => {
   //Uygulama Kategori Sayfası
   const { t, i18n } = useTranslation();
   if (!data?.length) {
      return null;
   }

   const metaDescription = i18n.language === 'en' ? enApplications.filter(e => e.applicationid === data[0].applicationid) : applications.filter(e => e.applicationid === data[0].applicationid)
   const alternates = getApplicationCategoryAlternates(data[0].applicationid, i18n.language);

   return (
      <>
         <section className="servcies-area gray-bg pt-115 pb-90">
            <div className="header-info position-absolute d-md-none flex" style={{ top: 75 }}>
               <a href="tel:+903125574646"> <span><i className="fas fa-phone"></i> +90 312 557 46 46</span></a>
               <a href="tel:+905332691271"> <span><i className="fas fa-phone"></i> +90 533 269 12 71</span></a>
            </div>
            <SEOHead
               title={`${data[0].applicationTitle} | Doç. Dr. Ebru Karagün`}
               description={`${metaDescription[0].description}`}
               image={data[0].image}
               trPath={alternates.trId ? `/uygulamalar/${alternates.trId}` : null}
               enPath={alternates.enId ? `/en/applications/${alternates.enId}` : null}
            />
            <div className="container">
               <div className="row">
                  <div className="col-xl-7 col-lg-8 col-md-12">
                     <div className="section-title pos-rel mb-75">
                        <div className="section-icon">
                           <img className="section-back-icon back-icon-left" src="/img/section/section-back-icon.png" alt="" />
                        </div>
                        <div className="section-text pos-rel">
                           <h2 className='sub-custom-header'>{t('applicationPage.header')}</h2>
                           <h1>{data[0].applicationTitle}</h1>
                        </div>
                        <div className="section-line pos-rel">
                           <img src="/img/shape/section-title-line.png" alt="" />
                        </div>
                     </div>
                  </div>
               </div>
               <div className="row">
                  {
                     data.map((e, i) => {
                        return <ServicesTwoSingleItem id={e.id} image={e.image} title={e.content?.blogPageTitle} description={e.content?.blogPageDesc}
                           applicationid={e.applicationid} />
                     })
                  }
               </div>
            </div>
         </section>
      </>
   );
};

export default ServicesTwoArea;
